'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _makeStyles = require('./../makeStyles');

var _makeStyles2 = _interopRequireDefault(_makeStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var useStyles = (0, _makeStyles2.default)(function () {
    return {
        root: {}
    };
});

/**
 * A container for tab content.
 */
var TabLayoutContent = _react2.default.forwardRef(function (props, ref) {
    var classes = useStyles();

    var children = props.children,
        className = props.className,
        rest = _objectWithoutProperties(props, ['children', 'className']);

    return _react2.default.createElement(
        'div',
        Object.assign({}, rest, {
            className: (0, _classnames2.default)(className, classes.root),
            ref: ref
        }),
        children
    );
});

TabLayoutContent.muiName = 'TabLayoutContent';
TabLayoutContent.displayName = 'TabLayoutContent';

TabLayoutContent.propTypes = {
    /**
     * A CSS class that will be applied to the parent `div`.
     */
    className: _propTypes2.default.string,
    /**
     * The content of the component.
     */
    children: _propTypes2.default.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object
};

exports.default = TabLayoutContent;